export default "__VITE_ASSET__CCfGDO4R__"